module.exports = "/static/assets/993ac0915457fb00edd1d4ee92ba9a08.png";